'use client'

import { SettingsSection } from '@/features/settings-modal/settings-section'
import { Button } from '@/components/ui/button'

export const CookieSettingsSection = () => {
    return (
        <SettingsSection
            title="Cookie Settings"
            description="Manage your cookie preferences and privacy settings"
            cta={
                <Button variant="secondary" className="cky-banner-element">
                    Manage
                </Button>
            }
        />
    )
}
